<template>
  <v-radio-group v-model="value" :error-messages="errorMessage" class="mt-0">
    <template #label>
      <p
        class="f-20 text-wrap"
        :class="[
          {
            'prepend-required': required
          },
          'font-weight-' + labelFontWeight
        ]"
      >
        {{ label }}
      </p>
    </template>
    <v-radio
      v-for="(item, index) in labels"
      :key="index"
      :value="item.value"
      :label="item.label"
      color="szViolet"
      :error="!!errorMessage"
    />
  </v-radio-group>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import { toRef } from 'vue'
import type { Maybe } from '@/types'

type Props = {
  labels?: { value: number; label: string }[]
  rules?: string
  name: string
  modelValue?: Maybe<number>
  label?: string
  required?: boolean
  labelFontWeight?: string
}

const props = withDefaults(defineProps<Props>(), {
  rules: '',
  labels: () => [],
  label: '',
  modelValue: null,
  labelFontWeight: 'bold'
})

const rulesRef = toRef(props, 'rules')

const { value, errorMessage } = useField(() => props.name, rulesRef, {
  syncVModel: true
})
</script>
